import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { Badge } from '@/shared/components/ui/badge'
import { Footer } from '@/shared/components/ui/layout'
import {
	PaginationControlled,
	usePagination,
} from '@/shared/components/ui/pagination-controlled'
import { Spinner } from '@/shared/components/ui/spinner'
import { useLocationQuery } from '@/shared/hooks/useLocationQuery'
import { formatNumber, NumberFormats } from '@/shared/tools/locale'

export default function StrategiesPageFooter({
	total,
	isFetching,
	totalOnPage,
}: {
	total: number
	isFetching: boolean
	totalOnPage: number
}) {
	const { t } = useTranslation()

	const [{ limit = 100, offset = 0 }, setQuery] = useLocationQuery()
	const pagination = usePagination({
		total,
		limit,
		offset,
		onChange: setQuery,
	})

	return (
		<Footer className='items-center space-x-2'>
			<PaginationControlled className='m-0 w-auto' pagination={pagination} />
			<Badge size='sm'>
				<div className='inline-flex items-center gap-1 text-xs'>
					<span>{t('app.total')}:</span>
					{isFetching ? (
						<Spinner data-testid='total-spinner' />
					) : (
						<Fragment>
							<strong data-testid='page-items-flat-count'>
								{formatNumber(totalOnPage, NumberFormats.Integer)}
							</strong>
							<strong>{t('general_of')}</strong>
							<strong data-testid='total-items-flat-count'>
								{formatNumber(total, NumberFormats.Integer)}
							</strong>
						</Fragment>
					)}
				</div>
			</Badge>
		</Footer>
	)
}
